import React from 'react';
import PropTypes from 'prop-types';
import styles from './instoreCollection.module.scss';
import { ResponsiveTable } from '../ResponsiveTable/ResponsiveTable';
import { TdResponsive, ThResponsive } from '../ResponsiveTable';
import { Tag } from '../../ds';
import { capitalized, hyphenEveryFourChars } from '../../Utils/formats';
import { statusColorTag } from '../../Utils/statusColorTag';

const tableHeaders = {
  paymentId: 'ID de pago',
  storeName: 'Sucursal',
  amount: 'Monto',
  createdAt: 'Fecha',
  kueskiAuthorization: 'Estatus',
  storeAuthorization: 'Confirmación del comercio',
  action: 'Acción',
};

const OrdersTable = ({
  ordersData,
  readOnlyPermission,
  goDetails,
  setSelecedOrder,
  setShowCancelOrder,
}) => (
  <ResponsiveTable type='b2b' className={styles.ordersTable}>
    <thead>
      <tr>
        <ThResponsive devices='desktop tablet mobile'>
          {tableHeaders.createdAt}
        </ThResponsive>
        <ThResponsive devices='desktop tablet mobile'>
          {tableHeaders.storeName}
        </ThResponsive>
        <th>{tableHeaders.paymentId}</th>
        <th>{tableHeaders.kueskiAuthorization}</th>
        <th>{tableHeaders.amount}</th>
        {!readOnlyPermission() && <th>{tableHeaders.action}</th>}
      </tr>
    </thead>
    <tbody>
      {ordersData.map(item => {
        const kueskiStatus = item.kueski_authorization;
        return (
          <tr key={item.order_id} className='row-hover'>
            <TdResponsive
              devices='desktop tablet mobile'
              dataTitle={tableHeaders.createdAt}
            >
              {item.created_at_formatted}
            </TdResponsive>
            <TdResponsive
              devices='desktop tablet mobile'
              dataTitle={tableHeaders.storeName}
            >
              {item.store_name}
            </TdResponsive>
            <TdResponsive dataTitle={tableHeaders.paymentId}>
              {!readOnlyPermission() ? (
                <button
                  onClick={async () =>
                    await goDetails(item.order_id, item.store_id)
                  }
                  className='link-button'
                >
                  {hyphenEveryFourChars(item.payment_id || '')}
                </button>
              ) : (
                hyphenEveryFourChars(item.payment_id || '')
              )}
            </TdResponsive>
            <td data-title={tableHeaders.kueskiAuthorization}>
              <Tag color={statusColorTag[kueskiStatus]}>
                {capitalized(String(kueskiStatus || '').toLowerCase())}
              </Tag>
            </td>
            <TdResponsive
              noWrap
              dataTitle={tableHeaders.amount}
            >{`$ ${item.total}`}</TdResponsive>
            {!readOnlyPermission() && (
              <TdResponsive
                devices='mobile tablet desktop'
                dataTitle={tableHeaders.action}
              >
                {kueskiStatus === 'AUTORIZADO' ? (
                  <button
                    onClick={async () => {
                      setSelecedOrder(item);
                      setShowCancelOrder(true);
                    }}
                    className='link-button'
                  >
                    Cancelar
                  </button>
                ) : null}
              </TdResponsive>
            )}
          </tr>
        );
      })}
    </tbody>
  </ResponsiveTable>
);

OrdersTable.propTypes = {
  ordersData: PropTypes.array.isRequired,
  readOnlyPermission: PropTypes.func.isRequired,
  goDetails: PropTypes.func.isRequired,
  setSelecedOrder: PropTypes.func.isRequired,
  setShowCancelOrder: PropTypes.func.isRequired,
};

export default OrdersTable;
